import { IEntitiesSelectedEvent } from './../components/entity-validation-selector';
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityConfigService } from "../services/entity-config-service";
import { SearchService } from "../services/search-service";
import { IPromise } from 'angular';
export function RLEntityRelationships(): ng.IDirective {
    var directive: ng.IDirective = {
        restrict: 'E',
        scope: {
            entityId: '=',
            relationshipCharTypeId: '=',
            selectedEntities: '=?',
            selectAllEntities: '=?',
            singleSelect: '=?',
            editMode: '@?',
            childCharTypeId: '=?',
            childTemplateId: '=?',
            relationshipId: '=?',
            childEntityId: '=?',
            childEntityRelationships: '=?',
            isRequired: "=?",
            createMode: '@?',
            childRecordId: '=?',
            isAdvancedSearchViewDisabled: "<?",
            onEntitiesSelected: "&",
            allowedTemplates: '=?'
        },
        bindToController: true,
        controller: EntityRelationshipsController,
        controllerAs: 'erVM',
        template: require("/assets/app/templates/entity-relationships.html")
    }

    return directive;
}

interface IEntityRelationshipBindings {
    onEntitiesSelected: (IEntitiesSelectedEvent) => void;
}

class EntityRelationshipsController implements IEntityRelationshipBindings {
    static $inject = ["$scope", "entityService", "notifyService", "eventService", "entityConfigService", "searchService", "$q"];

    public onEntitiesSelected: (IEntitiesSelectedEvent) => void;

    entityId: string;                       // parent entity to load available relationships from

    // ONLY ONE OF BELOW
    relationshipId: string;                 // relationshipID of child to load relationships from 
    childEntityId: string;                  // entityID of child to load relationships from

    childCharTypeId: number;                // child char type to load templates with
    childTemplateId: number;                // child template to load templates with

    relationshipCharTypeId: number;         // type of relationships we want to load for all of the above


    selectedEntities: Models.IEntitySearchDoc[];
    singleSelect: boolean;
    editMode: boolean;

    childEntityRelationships: Models.IEntityRelationship[];

    childEntity: Models.IEntity;
    childTemplates: Models.ICharacteristicTemplate[];   // dictionary of amount templates per usage

    //Helper objects
    charTypeName: string;
    charDataIDsAndNames: Models.ICharacteristicType[];
    isRequired: boolean;
    allowedTemplates: number[];
    openPanel: boolean;
    showRelated: boolean;
    isAdvancedSearchViewDisabled: boolean;
    //--

    //Pager
    keyword: string;
    selectedEntitiesCount: number;
    //--

    createMode: boolean;
    allRelatedToModuleLevelEntity: number;
    allRelatedToNonModuleLevelEntity: number;
    childRecordId: number;
    disableRelatedOptions: boolean;
    relatedCharTypeName: string;
    showParent: boolean;
    showChildren: boolean;
    showRelatedOptions: boolean;

    //Column Picker
    selectedCustomColumns: Models.ICustomUserColumns;
    itemRows: Models.IEntitySearchDoc[];

    sortField: string;			                                // sort by field (matches a solr field)
    previousSortField: string;
    sortDir: number;
    visibility: number;
    page: number;				                                // current page
    pageCount: number;			                                // current page	count of search	results
    rowCount: number;
    numFound: number;
    openLinkInNewTab: boolean;
    selectAllEntities: boolean;
    allRelatedCharTypeLabel: string;
    relatedCharTypeLabel: string;
    entityIDCharTypeID: number;
    entityIDCharTypeLabel: string;
    hasCatalogOrProjectRelConfigured: boolean;
    //--

    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    selectedTemplate: string;
    selectedStatus: string;
    public previousEntityIdsFromAdvancedView: string[] = [];

    constructor(
        private $scope: ng.IScope,
        public entityService: EntityService,
        public notifyService: NotifyService,
        public eventService: EventService,
        public entityConfigService: EntityConfigService,
        public searchService: SearchService,
        private $q: ng.IQService) {

    }

    $onInit() {
        this.editMode = false;
        this.childTemplates = [];
        this.selectAllEntities = false;

        this.charDataIDsAndNames = [];
        this.openPanel = false;

        this.selectedEntitiesCount = 0;

        this.showRelated = false;

        this.allRelatedToModuleLevelEntity = this.relationshipCharTypeId == 99 ? 3 : 1;
        this.allRelatedToNonModuleLevelEntity = 0;
        this.disableRelatedOptions = true;
        this.showParent = false;
        this.showChildren = false;
        this.showRelatedOptions = false;

        var firstRequest = true;

        //Column Picker
        this.itemRows = [];
        this.selectedEntities = [];

        this.sortField = "";			// sort by field (matches a solr field)
        this.previousSortField = "";
        this.sortDir = 0;				// sort by direction.  0 - asc, 1 - desc
        this.visibility = 1;
        this.page = 1;				    // current page
        this.pageCount = 1;			    // current page	count of search	results
        this.rowCount = 10;
        this.numFound = 0;
        this.openLinkInNewTab = true;
        //--
        this.allRelatedCharTypeLabel = "";
        this.relatedCharTypeLabel = "";
        if (this.singleSelect) {
            this.isAdvancedSearchViewDisabled = true;
        }
        this.$scope.$watchCollection(() => [this.entityId, this.relationshipCharTypeId, this.childCharTypeId, this.childTemplateId], (newValue, oldValue) => {
            if (_.any(newValue, v => v == null)) {
                return;
            }
            if ((newValue[0] != oldValue[0] && !_.isEmpty(newValue[0])) || newValue[1] != oldValue[1] || firstRequest) {
                this.entityIDCharTypeID = Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;
                if (this.charDataIDsAndNames.length == 0) {
                    this.LoadCharDataIDsAndNames()
                        .then(() => {
                            this.charTypeName = this.GetCharDataName(this.relationshipCharTypeId);
                            this.relatedCharTypeName = this.GetCharDataName(this.childCharTypeId);
                            if (this.entityIDCharTypeID == Consts.CharTypeIDs.relationship) {
                                //use the child char type of the rel
                                this.entityService.getEntityRelationship(this.entityId).then((r) => {
                                    this.entityIDCharTypeLabel = this.GetCharDataName(r.childCharTypeID);
                                });
                            }
                            else {
                                this.entityIDCharTypeLabel = this.GetCharDataName(this.entityIDCharTypeID);
                            }
                            if (this.childCharTypeId == Consts.CharTypeIDs.usage) {
                                this.allRelatedCharTypeLabel = "All " + this.relatedCharTypeName + " rows";
                                this.relatedCharTypeLabel = "This " + this.relatedCharTypeName + " row";
                            }
                            else if (this.childCharTypeId == Consts.CharTypeIDs.right) {
                                this.allRelatedCharTypeLabel = "All " + this.relatedCharTypeName + "sets";
                                this.relatedCharTypeLabel = "This " + this.relatedCharTypeName + "set";
                            }
                            else {
                                this.allRelatedCharTypeLabel = this.relatedCharTypeName + "s";
                                this.relatedCharTypeLabel = this.relatedCharTypeName;
                            }
                        });
                }

                this.entityService.getAssociatedTemplatesForTemplate(this.childCharTypeId, this.childTemplateId, this.relationshipCharTypeId)
                    .then((res) => {
                        this.childTemplates = res;
                        if (this.allowedTemplates == undefined || this.allowedTemplates.length == 0) {
                            this.allowedTemplates = _.map(this.childTemplates, (ct) => {
                                return ct.templateID;
                            });
                        }
                    })
                    .finally(() => {
                        if (this.childTemplates.length > 0) {
                            this.hasCatalogOrProjectRelConfigured = true;
                        }
                        else {
                            this.hasCatalogOrProjectRelConfigured = false;
                        }

                        this.GetRelationships()
                            .then(() => {
                                this.setSelectedRecords();
                            });
                    });
                firstRequest = false;
            }
        });

        this.$scope.$watch(() => this.selectedEntities, (newValue) => {
            this.CheckAllSelected();
        }, true);

        // if passed in, load relationships
        this.$scope.$watchCollection(() => [this.relationshipId, this.childEntityId], (newValue, oldValue) => {
            if (this.relationshipId || this.childEntityId) {
                var entityID = this.relationshipId || this.childEntityId;
                this.entityService.getEntityRelationships(entityID, this.relationshipCharTypeId)
                    .then((res) => {
                        this.childEntityRelationships = res;
                    });
            }
        });

        // if passed in, set selection to the child entity relationships
        this.$scope.$watch(() => this.childEntityRelationships, (newValue, oldValue) => {
            if (newValue && this.itemRows) {
                this.selectedEntities = [];
                this.setSelectedRecords();
            }
        });

        //Pager
        this.$scope.$watch(() => this.keyword, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.GetRelationships();
            }
        }, true);

        this.$scope.$watch(() => this.page, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.GetRelationships();
                this.selectAllEntities = false;
            }
        });

        this.$scope.$watch(() => this.allRelatedToModuleLevelEntity, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue > 1) {
                    if (this.createMode) {
                        this.disableRelatedOptions = true;
                    }
                    else {
                        this.disableRelatedOptions = false;
                        this.showRelatedOptions = true;
                    }
                    if (newValue == 3) {
                        this.allRelatedToNonModuleLevelEntity = 0;
                    }
                }
                else {
                    if (this.createMode) {
                        this.disableRelatedOptions = true;
                    }
                    this.allRelatedToNonModuleLevelEntity = 0;
                    this.showRelatedOptions = false;
                }
                this.GetRelationships();
            }
        });

        this.$scope.$watch(() => this.allRelatedToNonModuleLevelEntity, (newValue, oldValue) => {
            if (newValue != oldValue && newValue > 0) {
                this.GetRelationships();
            }
        });

        this.$scope.$watch(() => this.showParent, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.GetRelationships();
            }
        });

        this.$scope.$watch(() => this.showChildren, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.GetRelationships();
            }
        });

        this.$scope.$watch(() => this.selectedTemplate, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (this.page != 1) {
                    this.page = 1;
                }
                else {
                    this.GetRelationships();
                }
            }
        });

        this.$scope.$watch(() => this.selectedStatus, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (this.page != 1) {
                    this.page = 1;
                }
                else {
                    this.GetRelationships();
                }
            }
        });
    }

    ShowRelatedToggle() {
        this.showRelated = !this.showRelated;
        this.GetRelationships()
            .then(() => {
                this.setSelectedRecords();
            });
    }

    private setSelectedRecords() {
        if (this.childEntityRelationships && this.childEntityRelationships.length > 0) {
            if (this.selectedEntities.length == 0) {
                this.eventService.call(Consts.Events.EntityRelationshipsLoading);

                var recordIDs = this.childEntityRelationships.map(r => r.childRecID).join(",");

                var promises: IPromise<any>[] = [];
                if (recordIDs.length > 0) {
                    var promise = this.searchService.getSolrSearchResultForRecIDs(this.relationshipCharTypeId, recordIDs, 1000)
                        .then((results) => {
                            this.selectedEntities = results.documents;
                        });
                    promises.push(promise);
                } else {
                    this.selectedEntities = [];
                }
                this.$q.all(promises)
                    .then(() => {
                        this.selectedEntitiesCount = this.selectedEntities.length;
                        var selectedIDs = this.selectedEntities.map((ent) => { return ent.entityID });
                        var relationshipIDs = this.itemRows.map((row) => { return row.entityID });

                        if (this.selectedEntities.length > 5) {
                            this.openPanel = false;
                        }
                        else {
                            this.openPanel = true;
                        }

                        this.CheckAllSelected();

                        this.eventService.call(Consts.Events.EntityRelationshipsLoaded);
                    });
            }
        }
    }

    CheckAllSelected() {
        if (this.selectedEntities && this.itemRows && this.selectedEntities.length > 0 && this.itemRows.length > 0) {
            var selectedIDs = this.selectedEntities.map((ent) => { return ent.entityID });
            var relationshipIDs = this.itemRows.map((row) => { return row.entityID });

            this.selectAllEntities = _.intersection(selectedIDs, relationshipIDs).length === this.itemRows.length;

        }
    }

    GetRelationships(rowCount?: number, page?: number, shouldUpdateBasicView: boolean = true): ng.IPromise<any> {
        this.notifyService.startProgress();

        return this.getSearchRequest(rowCount, page).then((searchRelationshipRequest) => {
            return this.searchService.advanceSearchRelationships(searchRelationshipRequest)
                .then((results) => {
                    if (shouldUpdateBasicView) {
                        this.updateBasicView(results, this.getParentCharTypeId());
                    }
                    return results;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        });
    }

    private getSearchRequest(rowCount?: number, page?: number) {
        if (!rowCount) {
            rowCount = this.rowCount;
        }
        if (!page) {
            page = this.page;
        }
        return this.getSearchID().then((searchEntityId) => {

            var advanceSearchRequest: Models.IAdvancedSearchModel = {
                charTypeID: this.relationshipCharTypeId,
                searchGroups: [],
                keywords: this.keyword,
                rowCount: rowCount,
                page: page,
                relatedEntityID: searchEntityId,
                sortDir: this.sortDir,
                sortField: _.isEmpty(this.sortField) ? "title_sort" : this.sortField,
                templateGroupIDs: [1, 2],
                explicitRelationshipsOnly: this.showRelated ? false : true,
                filterByTemplateIds: this.allowedTemplates,
                template: this.selectedTemplate,
                status: this.selectedStatus
            };

            var searchRelationshipRequest: Models.IAdvanceSearchRelationshipModel = {
                advanceSearchRequest: advanceSearchRequest,
                allRelatedToModuleLevelEntity: this.allRelatedToModuleLevelEntity,
                allRelatedToNonModuleLevelEntity: this.allRelatedToNonModuleLevelEntity,
                childCharTypeID: this.childCharTypeId,
                childRecordID: this.childRecordId ? this.childRecordId : 0,
                childRecordTemplateID: this.childTemplateId,
                showParent: this.showParent,
                showChildren: this.showChildren,
                relationshipIndicator: this.relationshipCharTypeId == Consts.CharTypeIDs.user ? -1 : Consts.RelationshipIndicator.Default
            };

            return searchRelationshipRequest;
        });
    }

    private getSearchID() {
        if (this.childRecordId && this.relationshipCharTypeId == Consts.CharTypeIDs.property &&
            this.childCharTypeId == Consts.CharTypeIDs.amount &&
            this.getParentCharTypeId() == Consts.CharTypeIDs.invoice) {
            var divID = Utils.IdBuilder.splitEntityID(this.entityId).divID;
            // check to see if amount originates on a deal, if so, load that child catalog items from the deal -> table rel
            return this.entityService.getEntityParentRelationship(Utils.IdBuilder.buildEntityID(divID, this.childCharTypeId, this.childRecordId), Consts.CharTypeIDs.relationship).then((parentRel) => {
                if (_.any(parentRel)) {
                    return Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.relationship, parentRel[0].parentRecID);
                } else {
                    return this.$q.when(this.entityId);
                }
            });
        }
        else {
            return this.$q.when(this.entityId);
        }
    }

    private updateBasicView(results: Models.AdvancedSearchResult, parentCharTypeID: number) {
        this.itemRows = [];
        this.numFound = results.numFound;
        this.pageCount = Math.ceil(results.numFound / this.rowCount);
        this.templateFacets = results.getTemplateFacets();
        this.statusFacets = results.getStatusFacets();
        results.documents.forEach(er => {
            //Is this entity configured for the parent entity?
            if (this.allowedTemplates.indexOf(er.templateID) >= 0) {
                this.itemRows.push(er);
            }
        });
        if (this.isRequired) {
            if (this.itemRows.length == 1 && this.createMode && this.childCharTypeId == Consts.CharTypeIDs.right && (parentCharTypeID == Consts.CharTypeIDs.transaction || parentCharTypeID == Consts.CharTypeIDs.property)) {
                this.selectedEntities = _.cloneDeep(this.itemRows);
            }
            else if (this.itemRows.length == 1 && this.createMode && this.childCharTypeId == Consts.CharTypeIDs.usage) {
                this.selectedEntities = _.cloneDeep(this.itemRows);
            }
        }
    }

    LoadCharDataIDsAndNames() {

        return this.entityConfigService.getCharacteristicTypes()
            .then((results) => {
                this.charDataIDsAndNames = results;

                //We need to make sure this says Accounting and not Invoice
                var invoiceCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 7);
                if (this.relationshipCharTypeId == Consts.CharTypeIDs.user) {
                    invoiceCharType.charTypeName = "Accounting Document";
                }
                else {
                    invoiceCharType.charTypeName = "Accounting Documents";
                }

                //We need to make sure this says Catalog Items and not Catalog
                var catalogCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 1);
                if (this.relationshipCharTypeId == Consts.CharTypeIDs.user) {
                    catalogCharType.charTypeName = "Catalog Item";
                }
                else {
                    catalogCharType.charTypeName = "Catalog Items";
                }

                //We need to make sure this says Projects and not Project
                var projectCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 16);
                if (this.relationshipCharTypeId == Consts.CharTypeIDs.user) {
                    projectCharType.charTypeName = "Project";
                }
                else {
                    projectCharType.charTypeName = "Projects";
                }

                //We need to make sure this says Contacts and not Contact
                var contactCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 2);
                if (this.relationshipCharTypeId == Consts.CharTypeIDs.user) {
                    contactCharType.charTypeName = "Contact";
                }
                else {
                    contactCharType.charTypeName = "Contacts";
                }

                //We need to make sure this says Relative Items and not Mock
                var mockCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 99);
                if (this.relationshipCharTypeId == Consts.CharTypeIDs.user) {
                    mockCharType.charTypeName = "Relative Item";
                }
                else {
                    mockCharType.charTypeName = "Relative Items";
                }
            })
    }

    GetCharDataName(charTypeID: number): string {
        if (_.find(this.charDataIDsAndNames, c => c.charTypeID == charTypeID) != null) {
            return _.find(this.charDataIDsAndNames, c => c.charTypeID == charTypeID).charTypeName;
        }
        else {
            return "";
        }
    }

    //Column Picker & List Table
    PageChanged(page: number) {
        this.page = page;
        this.GetRelationships();
    }

    PageSizeChanged(pageSize: number) {
        this.page = 1;
        this.rowCount = pageSize;
        this.GetRelationships();
    }

    ColumnsSelected(columns: Models.ICustomUserColumns) {
        this.selectedCustomColumns = columns;
        this.GetRelationships();
    }

    SortChanged(sortField: string, sortDir: number) {
        if (this.itemRows.length > 0) {
            var field = this.itemRows[0].characteristics[sortField];
            if (Array.isArray(field)) {
                this.sortField = this.previousSortField;
                return;
            }
        }

        this.previousSortField = sortField;

        this.sortField = sortField;
        this.sortDir = sortDir;
        this.GetRelationships();
    }

    public selectEntities(event: IEntitiesSelectedEvent): void {
        let entityIdsFromAdvancedView = event.validEntityIdsAndTitles.map(eat => eat.entityId);
        let previouslySelectedEntityIds = this.selectedEntities.map(entity => entity.entityID);
        let entityIdsToRemove = [];
        if (this.previousEntityIdsFromAdvancedView.length > 0) {
            entityIdsToRemove = this.previousEntityIdsFromAdvancedView.filter(entityId => !_.includes(entityIdsFromAdvancedView, entityId));
            previouslySelectedEntityIds = previouslySelectedEntityIds.filter(entityId => !_.includes(entityIdsToRemove, entityId));
        }
        this.previousEntityIdsFromAdvancedView = entityIdsFromAdvancedView;
        if (_.all(entityIdsFromAdvancedView, entityId => {
            return _.includes(this.itemRows.map(itemRow => itemRow.entityID), entityId);
        })) {
            this.setSelectedEntities(this.itemRows, entityIdsFromAdvancedView, previouslySelectedEntityIds);
        } else {
            this.GetRelationships(this.numFound, 1, false).then((results) => {
                this.setSelectedEntities(results.documents, entityIdsFromAdvancedView, previouslySelectedEntityIds);
            });
        }
    }

    private setSelectedEntities(itemRows: Models.IEntitySearchDoc[], entityIdsFromAdvancedView: string[], previouslySelectedEntityIds: string[]): void {
        this.selectedEntities = itemRows.filter(doc => _.includes(entityIdsFromAdvancedView, doc.entityID) || _.includes(previouslySelectedEntityIds, doc.entityID));
    }

    public getParentCharTypeId(): number {
        return Utils.IdBuilder.splitEntityID(this.entityId).charTypeID;
    }

    public getParentRecordId(): number {
        return Utils.IdBuilder.splitEntityID(this.entityId).recID;
    }

    public get isSelectedCatalogListVisible() {
        return this.editMode && this.relationshipCharTypeId === 1 && this.selectedEntities.length > 0;
    }

    public deselectEntity(entityId: string): void {
        _.remove(this.selectedEntities, catalog => catalog.entityID === entityId);
        this.selectedEntitiesCount = this.selectedEntities.length;
    }
}